import moment from "moment";
import hub from "../scripts/_hub";

export default {
	/**
	 * Translate specified text/key
	 * @param {*} text The text/key to translate
	 * @returns The translated text
	 */
	T(text) {
		return hub.ui.versions.versioned(text, arguments);
	},
	/**
	 * Get currently selected products of the specified reservation
	 * @param {*} reservation The reservation
	 * @returns List of selected products
	 */
	getSelectedProducts(reservation) {
		const selectedProducts = [];
		// Handle multidate
		if (reservation.MultiDate.IsActive && reservation.MultiDate.Sets.length > 0) {
			reservation.MultiDate.Sets.forEach(s => {
				s.Products.forEach(p => {
					selectedProducts.push(p);
				});
			});
		}

		// for services we use legacy code, so just check product count here
		if (reservation.Mode === "Services") {
			const serviceProducts = reservation.Products.filter(d => d.Count > 0);
			selectedProducts.push(...serviceProducts);
			return selectedProducts;
		}

		// return all products with a tariff count
		const currentlySelectedProducts = reservation.Products.filter(d => d.Tariffs.some(d => d.Count > 0));
		selectedProducts.push(...currentlySelectedProducts);
		return selectedProducts;
	},
	/**
	 * Check whether the specified discount is valid
	 * @param {*} reservation The reservation
	 * @param {*} discount The discount
	 * @returns true if valid, otherwise false.
	 */
	isDiscountValid(reservation, discount) {
		if (reservation.Discounts.length === 0 || !reservation.Discounts[0].isSelected) {
			discount.errorMessage = "";
			return true;
		} else {
			let isValid = true;
			reservation.Discounts[0].References.Groups.forEach(
				g => {
					if (g.And) {
						g.And.forEach(a => {
							const product = reservation.Products.find(p => p.Product === a.Product);
							isValid = isValid && product && product.Count >= a.MinCount && product.Count <= a.MaxCount;
						})
					}
					if (g.Or) {
						let orIsValid = false;
						g.Or.forEach(o => {
							var product = reservation.Products.find(p => p.Product === o.Product);
							orIsValid = orIsValid || (product && product.Count >= o.MinCount && product.Count <= o.MaxCount);
						});
						isValid = isValid && orIsValid;
					}
				}
			);
			discount.errorMessage = isValid ? "" : this.T("OneTicketing_Please_select_adults_children");
			return isValid;
		}
	},
	/**
	 * Check whether an adult ticket is required for this reservation and channel
	 * @param {*} reservation The current reservation
	 * @param {*} channel The channel
	 * @returns true, if an adult ticket is required, otherwise false.
	 */
	isAdultTicketRequired(reservation, channel) {
		if (channel._oid === 120714) {
			let selectedProducts = this.getSelectedProducts(reservation);
			const products = selectedProducts.map((selectedProduct) => reservation.fn.getProduct(selectedProduct));

			let hasChild = products.some(x => x.Age.Min >= 0 && x.Age.Max < 18);
			let hasAdults = products.some(x => x.Age.Min == null && x.Age.Max == null);

			return hasChild && !hasAdults;
		}

		return false;
	},
	/**
	 * Check if the specified reservation can proceed to the checkout
	 * @param {*} reservation The reservation to check
	 * @param {*} channel The channel
	 * @returns true, if the reservation can proceed to checkout, otherwise false
	 */
	canCheckoutReservation(reservation, channel) {
		let validationErrors = [];
		const selectedProducts = this.getSelectedProducts(reservation);

		// check ticket selection
		let noTicketsSelected = selectedProducts.length === 0;

		// For service, just check if we have a ticket selected
		if (reservation.Mode === "Services") {
			return {
				isValid: !noTicketsSelected,
				validationErrors: [this.T("OneTicketing_select_appointment_to_continue")]
			}
		}

		let invalidShiftSelected, anyDiscountInvalid, isCountInvalid, hasRequiredAdultTickets;

		// check date except for seasonal products
		if (reservation.Mode !== "Seasonal" && reservation.Mode !== "Multi") {
			if (reservation.Mode === "Dates") {
				let date = moment(reservation.Query.From.Date).add(reservation.From.TimeFrame.Times.Start, "minutes");
				invalidShiftSelected = date < moment();
			} else {
				let date = moment(reservation.Query.From.Date).add(reservation.From.TimeFrame.Times.End, "minutes");
				invalidShiftSelected = date < moment();
			}
		}

		// check discounts
		anyDiscountInvalid = reservation.Discounts.some(d => !this.isDiscountValid(d));
		hasRequiredAdultTickets = this.isAdultTicketRequired(reservation, channel);

		// count

		if (channel.Restrictions && channel.Restrictions.MaxCount) {
			var count = 0;
			selectedProducts.forEach(s => count += s.Count);
			isCountInvalid = count > channel.Restrictions.MaxCount && !this.isRestrictionOverPassed("MaxTickets");
		}

		//
		const isInvalid = noTicketsSelected || invalidShiftSelected || anyDiscountInvalid || isCountInvalid || hasRequiredAdultTickets;

		// build validation erros
		if (noTicketsSelected) validationErrors.push(this.T("OneTicketing_select_appointment_to_continue"));
		if (hasRequiredAdultTickets) validationErrors.push(this.T("OneTicketing_Please_select_adult_ticket"));
		if (invalidShiftSelected) validationErrors.push(this.T("OneTicketing_selected_appointment_is_in_the_past"));
		if (anyDiscountInvalid) validationErrors.push(this.T("OneTicketing_Check_selected_discount"));
		if (isCountInvalid) validationErrors.push(this.T("OneTicketing_maxPersons_start") + " " + channel.Restrictions.MaxCount + " " + this.T("OneTicketing_maxPersons_end"));

		return {
			isValid: !isInvalid,
			validationErrors,
		};
	}
}